<template>
  <div class="containerPage">
    <div class="title">
      {{ $t('formPage.title') }}
    </div>
    <div>
      <div class="w-full h-0">
        <img src="../assets/icons/spacecraftIcon.svg" alt="Kaffea Terra spacecraft"
             class="w-[10vw] relative left-[35%]">
      </div>
      <Transition name="fade">
        <img :src="imageSrc" alt="Kaffea Terra Gifts" class="gifts"
             v-if="showImage">
      </Transition>
      <div class="w-full flex flex-row justify-between">
        <img src="../assets/icons/starIcon.svg" alt="Kaffea Terra star" class="w-[4vw]">
        <img src="../assets/icons/movingstarIcon.svg" alt="Kaffea Terra moving star" class="w-[8vw]">
      </div>
      <form @submit.prevent="handleSubmit" class="containerForm">
        <div class="formTitle">
          {{ $t('formPage.formTitle') }}
        </div>
        <div class="mb-[2vw] flex gap-[2vw]">
          <input type="text" id="fname" :value="userInfo.fname" @input="updateFName($event.target.value)" required
                 class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-1/2 py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
                 :placeholder="$t('formPage.fnamePlaceholder')"/>

          <input type="text" id="lname" :value="userInfo.lname" @input="updateLName($event.target.value)" required
                 class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-1/2 py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
                 :placeholder="$t('formPage.lnamePlaceholder')"/>
        </div>
        <div class="mb-[2vw]">
          <input type="email" id="email" :value="userInfo.email" @input="updateEmail($event.target.value)" required
                 class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-full py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
                 :placeholder="$t('formPage.emailPlaceholder')"/>
        </div>
        <div class="gdprLabel flex items-center mb-[70px]">
          <div class="flex items-center h-5">
            <input id="gdpr" type="radio" name="gdpr" :value="true"
                   @input="updateAcceptGdpr($event.target.value)" required
                   class="text-6xl grid grid-cols-2 gap-[2vw] w-[5vw] h-[5vw] text-[#101B53] bg-[#F0F0F0] focus:ring-transparent">
          </div>

          <label for="gdpr" class="ms-[2vw] text-[4vw] text-[#101B53] uppercase underline">
            {{ $t('formPage.gdprPlaceholder') }}
          </label>
        </div>
        <button type="submit" :disabled="!isFormValid"
                class="text-[4.5vw] text-white bg-[#101B53] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[100vw] w-full px-5 py-3 text-center">
          {{ $t('formPage.submitButton') }}
        </button>
      </form>
    </div>
  </div>

  <div class="flex justify-end gap-[1vw] absolute bottom-0 w-full">
    <div class="opacity-[0.3]">
      <img src="@/assets/arrowleft.svg" alt="arrow-left" class="w-[5vw] h-[5vw]">
    </div>
    <div class="opacity-[0.3]">
      <img src="@/assets/arrowright.svg" alt="arrow-right" class="w-[5vw] h-[5vw]">
    </div>
  </div>

  <div v-if="toastMessage" class="fixed bottom-5 left-1/2 transform -translate-x-1/2">
    <div id="toast-warning"
         class="flex items-center p-4 w-auto max-w-full text-gray-500 bg-white rounded-lg shadow-lg"
         role="alert">
      <div
          class="inline-flex items-center justify-center flex-shrink-0 w-[3vw] h-[3vw] text-yellow-500 bg-yellow-100 rounded-lg">
        <svg class="w-[2.5vw] h-[2.5vw]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
             viewBox="0 0 20 20">
          <path
              d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z"/>
        </svg>
        <span class="sr-only">Warning icon</span>

      </div>
      <div class="ml-3 text-[4vw] font-light uppercase whitespace-nowrap">{{ toastMessage }}</div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import giftsPage from '@/assets/giftsPage.png';
import giftsPageEnglishVersion from '@/assets/giftsPageEnglishVersion.png';

export default {
  props: {
    userInfo: Object
  },
  data() {
    return {
      showImage: false,
      submitted: false,
      toastMessage: '',
      route: useRoute()
    };
  },
  mounted() {
    this.showImage = true;
  },
  computed: {
    imageSrc() {
      return this.route.path === '/en' ? giftsPageEnglishVersion : giftsPage;
    },
    isFormValid() {
      return this.userInfo.fname.trim() !== '' &&
          this.userInfo.lname.trim() !== '' &&
          this.userInfo.email.trim() !== '' &&
          this.userInfo.acceptGdpr;
    },
  },
  methods: {
    updateFName(value) {
      this.$emit('update-user-info', {...this.userInfo, fname: value});
    },
    updateLName(value) {
      this.$emit('update-user-info', {...this.userInfo, lname: value});
    },
    updateEmail(value) {
      this.$emit('update-user-info', {...this.userInfo, email: value});
    },
    updateAcceptGdpr(value) {
      const isAccepted = value === 'true';
      this.$emit('update-user-info', {...this.userInfo, acceptGdpr: isAccepted});
    },
    showToast(message) {
      this.toastMessage = message;
      setTimeout(() => {
        this.toastMessage = '';
      }, 3000);
    },
    async handleSubmit() {
      let now = new Date()
      let dataForCollectionData = {
        fname: this.userInfo.fname,
        lname: this.userInfo.lname,
        email: this.userInfo.email,
        expo: this.$t('emailInfo.expoDetail'),
        date: (now.getTime()),
        spin: false
      }

      await fetch('https://kafea-terra-form-api.ocm.workers.dev/', {
        method: 'POST',
        body: JSON.stringify(dataForCollectionData),
        headers: {'content-type': 'application/json'}
      })
          .then(response => {
            console.log(response.status)
            if (this.isFormValid && (response.status !== 409 && response.status !== 404 && response.status !== 500)) {
              this.submitted = true;
              this.$emit('submit-user-info');
            } else if (response.status === 409) {
              this.showToast(this.$t('formPage.toastMsg'));
            }
          })
          .catch(error => console.error('Error upload user:', error));
    },
  }
};
</script>

<style scoped>
.containerPage {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  @media only screen and (max-width: 1000px) {
    gap: 20px;
  }
  @media only screen and (max-width: 750px) {
    gap: 10px;
  }
}

.title {
  text-align: center;
  font-size: 6vw;
  line-height: normal;
  color: #FFFFFF;
  text-transform: uppercase;
  padding-bottom: 20px;
  @media only screen and (max-width: 1000px) {
    padding: 0;
  }
}

.gifts {
  width: 100%;
}

.containerForm {
  background: white;
  border-radius: 20px;
  padding: 73px 70px;
  margin-bottom: 200px;
  width: 100%;

  @media only screen and (max-width: 1000px) {
    padding: 40px;
    margin-bottom: 100px;
  }

  @media only screen and (max-width: 750px) {
    padding: 20px;
    margin-bottom: 50px;
  }
}

.formTitle {
  text-align: center;
  font-size: 4.5vw;
  line-height: normal;
  color: #101B53;
  text-transform: uppercase;
  padding-bottom: 55px;

  @media only screen and (max-width: 1000px) {
    padding-bottom: 45px;
  }

  @media only screen and (max-width: 750px) {
    padding-bottom: 25px;
  }
}

.gdprLabel {
  @media only screen and (max-width: 1000px) {
    margin-bottom: 45px;
  }

  @media only screen and (max-width: 750px) {
    margin-bottom: 25px;
  }

  @media only screen and (max-width: 600px) {
    input {
      font-size: 1.75rem;
    }
  }
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #ccc;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media only screen and (max-width: 400px) {
  #toast-warning {
    padding: 0.5rem;
  }
}
</style>